(function(){
  "use strict";

  angular.module("app.common")
  .directive("sidebarStayUpdatedForm", function(){
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        image:'@',
        title:'@',
        sub: '@',
        button: '@',
        regionDropdown: '@',
        classname: '@',
        analyticsConfig: '=',
        formType: '@'
      },
      templateUrl: '/directive/sidebar-stay-updated-form'
    };
  });
}());